export function formatCurrency(amount, currency = "ZAR", locale = "en-CH") {
  const numericAmount = Number(amount);
  const currencyCode = String(currency || "ZAR").trim().toUpperCase() || "ZAR";

  if (!Number.isFinite(numericAmount)) return "—";

  try {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: currencyCode,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(numericAmount);
  } catch {
    return `${currencyCode} ${numericAmount.toFixed(2)}`;
  }
}

export function formatCurrencyFromCents(cents, currency = "ZAR", locale = "en-CH") {
  const numericCents = Number(cents);
  if (!Number.isFinite(numericCents)) return "—";
  return formatCurrency(numericCents / 100, currency, locale);
}
